// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__RbFge","content":"Layout_content__W9o5j","withHeaderSizeMargin":"Layout_withHeaderSizeMargin__jxbca"};